import React, { useState } from 'react';

import AuthContainer from '../auth/AuthContainer';

import PostFormModal from '../PostFormModal';
import DefaultPageModal from '../DefaultPage/DefaultPageModal';
import Check from '../Icons/Check';
import styles from './BottomBar.module.scss';
import { useUser } from '../../config/UserContext';
import { useNotifications } from '../../config/NotificationContext';
import { Link } from 'react-router-dom';
import { auth } from '../../config/firebase';
import Search from '../Icons/Search';

import Home from '../Icons/Home';
import Notification from '../Icons/Notification';
import NotificationActive from '../Icons/NotificationActive';
import Plus from '../Icons/Plus';
import useHasPostedToday from '../../hooks/useHasPostedToday';
import { useNavigation } from '../../config/NavigationContext';

const BottomBar = ({ openSongPage: openSongPageProp }) => {
  const { currentUser } = useUser(); // Fetch currentUser from UserContext
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDefaultPageModalOpen, setDefaultPageModalOpen] = useState(false);
  const userId = auth.currentUser ? auth.currentUser.uid : null;
  const { hasUnreadNotifications } = useNotifications();
  const { handleSearchNav, openSongPage: openSongPageFromNav } =
    useNavigation();
  const openSongPage = openSongPageProp ?? openSongPageFromNav;

  const alreadyPosted = useHasPostedToday(userId);

  return (
    <>
      {!currentUser ? (
        <div className={styles.loggedOutContainer}>
          <AuthContainer />
        </div>
      ) : (
        <>
          <div className={styles.container}>
            <Link className={styles.navLink} to="/">
              <Home fill="#404040" />
            </Link>

            <Link className={styles.navLink} to={`/notifs/${userId}`}>
              {hasUnreadNotifications ? (
                <NotificationActive fill="#404040" />
              ) : (
                <Notification fill="#404040" />
              )}
            </Link>
            {process.env.REACT_APP_STRIKE_MODE !== 'true' &&
              (alreadyPosted ? (
                <button
                  className={styles.postedCTA}
                  onClick={() => setModalOpen(true)}
                >
                  <Check fill="#404040" />
                </button>
              ) : (
                <button
                  className={styles.postCTA}
                  onClick={() => setModalOpen(true)}
                >
                  <Plus fill="#404040" />
                </button>
              ))}
            <Link
              className={styles.navLink}
              onClick={(e) => {
                e.preventDefault();
                handleSearchNav();
              }}
              to="#"
            >
              <Search />
            </Link>
            <Link className={styles.navLink} to={currentUser?.handle ? `/user/@${currentUser.handle}` : `/user/${userId}`}>
              <img
                className={styles.bottomBarAvatar}
                src={currentUser?.avatar || '../avatar.png'}
                alt="avatar"
              />
            </Link>
          </div>
          <PostFormModal
            show={isModalOpen}
            onClose={() => setModalOpen(false)}
          />
          <DefaultPageModal
            show={isDefaultPageModalOpen}
            onClose={() => setDefaultPageModalOpen(false)}
            openSongPage={openSongPage}
          />
        </>
      )}
    </>
  );
};

export default BottomBar;
